import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  heading: {
    textAlign: "center",
    fontSize: "4rem",
    fontWeight: tokens.fontWeightRegular,
    fontFamily: "Segoe UI Variable",
    lineHeight: "normal",
    ...shorthands.margin("0px"),

    "@media (max-width: 540px)": {
      fontSize: "1.5rem",
      fontWeight: "600",
      fontFamily: "Segoe UI",
      lineHeight: "2rem",
      fontStyle: "normal",
    },
  },

  main: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    ...shorthands.gap("3rem"),
    "@media (max-width: 540px)": {
      ...shorthands.gap("2rem"),
    },
  },

  promptLib: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  allPrompts: {
    ...shorthands.padding("0px"),
    "@media (max-width: 1422px)": {
      maxWidth: "unset",
    },

    "@media (max-width: 953px) and (min-width: 541px)": {
      maxWidth: "unset",
      ...shorthands.padding("0px"),
      width: "100%",
    },

    "@media (max-width: 540px)": {
      width: "100%",
    },
  },

  viewMoreBtnWrapper: {
    display: "flex",
    justifyContent: "center",
  },

  viewMoreBtn: {
    color: tokens.colorBrandForeground1,
  },
});
